import type { NotificationMethod, NotificationMethodDto } from './notification-settings.types';

export const mapNotificationMethod = ({
  user_id,
  created_at,
  updated_at,
  device_id,
  device_name,
  ...values
}: NotificationMethodDto): NotificationMethod => ({
  ...values,
  userId: user_id,
  createdAt: created_at,
  updatedAt: updated_at,
  deviceId: device_id,
  deviceName: device_name,
});
